import {
  getData,
  postData,
  convertPageModel
} from './api-base.service'

export const userLogin = (name, password, loginType, deviceid, deviceName) => {
  let data = {
    UserName: name,
    Password: password,
    LoginType: loginType,
    IsVideo: true,
    DeviceId: deviceid,
    DeviceName: deviceName
  };
  var result = postData('/User/Login', data, false);
  return result;
}

export const validateToken = () => {
  var result = getData('/User/ValidateToken');
  return result;
}

export const resetPassword = (form, resetType) => {
  let userId = 0;
  if (form.userId) {
    userId = form.userId;
  }
  if (typeof resetType == "undefined"){
    resetType = 1;
  }

  let data = {
    Id: userId,
    PasswordResetType: resetType,
    Password: form.password,
    ConfirmPassword: form.confirmPassword
  };

  if (resetType == 2){
    data.Id = form.studentId;
  }

  var result = postData('/User/ResetPassword', data);
  return result;
}

export const validateWechatUser = (code) => {
  let data = {
    code: code,
  }
  var result = getData('/User/ValidateWechatUser', data);
  return result;
}



// WEBPACK FOOTER //
// ./src/service/user.service.js